import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../../public/BerkeleyMonoVariable.woff2%22}],%22variableName%22:%22berkeleyMonoVariable%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'berkeleyMonoVariable', 'berkeleyMonoVariable Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
